import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { sortBy } from 'lodash-es';
import { NavigationActionButton } from './models/navigation-action-button.model';
import { fadeIn, fadeOut } from 'src/app/animations';
import { NetworkConnectionService } from 'src/app/services/ui/network-connection.service';
import { UserAuthService } from 'src/app/services/user-auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-navigation-bar',
	templateUrl: './navigation-bar.component.html',
	styleUrls: ['../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss', '../stylesheets/job-contacts.scss', './navigation-bar.component.scss'],
	animations: [fadeIn(200), fadeOut(200)]
})
export class NavigationBarComponent implements OnInit, OnDestroy {
	@ViewChild('preferencesModal', { static: true }) public preferencesModal: GenericModalComponent;
	public self = this;
	public isDropdownOpen = false;
	public isOnline: boolean = true;
	public readonly GlobalSettingsService = GlobalSettingsService;
	public readonly PageType = PageType;
	public isHelpRequestModalVisible = false;
	public hasUserAccountId = false;
	public sites = [];
	private unsubscriber$: Subject<void> = new Subject<void>();

	@HostListener('window:click')
	onGlobalClick(): void {
		this.isDropdownOpen = false;
	}

	public get actions() {
		return GlobalSettingsService.priorityNavigationBarActions || GlobalSettingsService.navigationBarActions;
	}

	public get navigationActions(): { key: string, value: NavigationActionButton }[] {
		const kvpArray = Array.from(this.actions.keys()).map(key => ({
			key,
			value: this.actions.get(key)
		}));

		return sortBy(kvpArray, [
			(item: { key: string, value: NavigationActionButton }) => item.value.listOrder || 0
		]);
	}

	public get navigationBarActionIds(): string[] {
		const buttons = this.navigationActions.filter(item => !item.value.isInDropdownMenu);
		return buttons.map(item => item.key).reverse();		// Reverse for right-to-left ordering
	}

	public get dropdownMenuActionIds(): string[] {
		const buttons = this.navigationActions.filter(item => !!item.value.isInDropdownMenu);
		return buttons.map(item => item.key);
	}

	constructor(
		private networkConnection: NetworkConnectionService,
		private userAuthService: UserAuthService,
	) { 

		this.networkConnection.isOnline.subscribe(isOnline => {
			this.isOnline = isOnline
		})
	}

	ngOnInit(): void {
		this.getSites();
	}

	public onToggleHelpVisibility(isVisible) {
		this.isHelpRequestModalVisible = isVisible;
		if (isVisible) {
			this.getSites();
		}
	}

	private getSites() {
		if (window.location.pathname) {
			const hashToken = window.location.pathname.split('/')[1];
			const splitPaths =window.location.pathname.split('/');
			const excludedPages = ['site-note', 'procedure-confirmation']

			if (hashToken.length > 14 && hashToken !== 'workforce-report-bysite' && hashToken !== 'workforce-report' && !!splitPaths.length && !excludedPages.includes(splitPaths[splitPaths.length - 1]) ) {
				this.userAuthService
					.getSites(hashToken)
					.pipe(takeUntil(this.unsubscriber$))
					.subscribe(
						result => {
							this.sites = result.accountSites;
							this.hasUserAccountId = result.userAccountType ? true : false;
						},
						err => {
							this.hasUserAccountId = false;
						}
					);
			}
		}
	}

	ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}
}
